__turbopack_context__.v({
  "card": "index-module-scss-module__L4xcaa__card",
  "gridContainer": "index-module-scss-module__L4xcaa__gridContainer",
  "stars": "index-module-scss-module__L4xcaa__stars",
  "testimonialTextDiv": "index-module-scss-module__L4xcaa__testimonialTextDiv",
});
